exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tw *:not(i):not([class*=el-icon]){font-family:\"IBM Plex Sans Thai\" !important\n}\n.tw-layout{height:100vh;overflow:hidden\n}\n#map div[style*=crosshair]{cursor:url(" + require("src/assets/img/common/plus.png") + "),crosshair !important\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1480ba57","scoped":false,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js?{"sourceMap":false}!./~/sass-resources-loader/lib/loader.js?{"resources":"/home/jenkins/agent/workspace/tmsui/src/assets/css/variables.scss"}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 1104
// module chunks = 159